// extracted by mini-css-extract-plugin
export default {"home":"Home_home__dDnPP","row":"Home_row__8HFqK","buttonStyle":"Home_buttonStyle__9puNI","menuItem":"Home_menuItem__a-uCv"};